// extracted by mini-css-extract-plugin
module.exports = {"row":"_2HZRfhV2cT2SzHA2O8gvNj","col":"_2_MHH2KL8rO4DczfRFkaYm"};